import React from 'react';
import PropTypes from 'prop-types';

// Lodash
import _noop from 'lodash/noop';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { VIEW_TYPE } from '../../../constants/note.general';

// Components
import NoteReader from '../../../Note.reader';
import NoteInput from '../../../NoteEditor/NoteInput';
import NoteView from '../noteView';
import styles from './defaultNoteItem.module.scss';
var DefaultNoteItem = function DefaultNoteItem(props) {
  var editing = props.editing,
    userImage = props.userImage,
    userName = props.userName,
    userRole = props.userRole,
    noteDate = props.noteDate,
    hideActions = props.hideActions,
    noteActions = props.noteActions,
    noteText = props.noteText,
    isNoteEdited = props.isNoteEdited,
    handleAddOrUpdate = props.handleAddOrUpdate,
    validators = props.validators,
    className = props.className,
    associatedUsers = props.associatedUsers,
    enableMentions = props.enableMentions,
    personas = props.personas;
  var noteUpdateStatus = {
    isUpdate: true
  };
  var buttonLabel = NoteReader.getButtonLabel(noteUpdateStatus);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.defaultNoteItem, " ").concat(className)
  }, editing ? /*#__PURE__*/React.createElement(NoteInput, {
    view: VIEW_TYPE.DEFAULT,
    buttonLabel: buttonLabel,
    note: noteText,
    image: userImage,
    handleAddOrUpdate: handleAddOrUpdate,
    validators: validators,
    userName: userName,
    associatedUsers: associatedUsers,
    enableMentions: enableMentions,
    personas: personas
  }) : /*#__PURE__*/React.createElement(NoteView, {
    userImage: userImage,
    userName: userName,
    userRole: userRole,
    noteDate: noteDate,
    hideAction: hideActions,
    noteActions: noteActions,
    noteText: noteText,
    isNoteEdited: isNoteEdited,
    associatedUsers: associatedUsers,
    enableMentions: enableMentions
  }));
};
DefaultNoteItem.propTypes = {
  editing: PropTypes.bool,
  userImage: PropTypes.string,
  userName: PropTypes.string.isRequired,
  userRole: PropTypes.string,
  noteDate: PropTypes.string,
  hideActions: PropTypes.bool,
  noteActions: PropTypes.array,
  noteText: PropTypes.string,
  isNoteEdited: PropTypes.bool,
  handleAddOrUpdate: PropTypes.func,
  validators: PropTypes.array,
  className: PropTypes.string,
  associatedUsers: PropTypes.object,
  enableMentions: PropTypes.bool,
  personas: PropTypes.array
};
DefaultNoteItem.defaultProps = {
  editing: false,
  userImage: '',
  userRole: '',
  noteDate: undefined,
  hideActions: false,
  noteActions: EMPTY_ARRAY,
  noteText: '',
  isNoteEdited: false,
  handleAddOrUpdate: _noop,
  validators: EMPTY_ARRAY,
  className: '',
  associatedUsers: EMPTY_OBJECT,
  enableMentions: false,
  personas: EMPTY_ARRAY
};
export default DefaultNoteItem;